
import { useState } from 'react';
import style from './register.module.css'
import axios from 'axios';
import { useAuthLocalStorage } from '../../modules/useLocalStore';

function Auth({page , setPage, stage , setStage, myProfile , setMyProfile}){
    const [login,setLogin] = useState('');
    const [password,setPassword] = useState('');

    const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
    const handleLoginChange = (e) => {
        setLogin(e.target.value);
    };
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };
    const { saveToken } = useAuthLocalStorage();
    const handleLogin = () => {
        
        const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/login`;
        const metaDate = {
            "login" : login,
            "password" : password
        };       

        axios.post(url,  metaDate)
        .then(response => {
            if(response.data.auth === false)
            {
                PopupOpen(15);
            }
            else
            {
                saveToken(response.data.token);
                setPage(0);
                PopupOpen(19);
            }
        })
            .catch(error => {
                console.error(error);
        });
    
    };
    

    return(
       <div className={style.authbox}>
            <h4>Войти в аккаунт</h4>
            <input className={style.inputb} value={login} onChange={handleLoginChange} placeholder='Логин' />
            <input className={style.inputb} value={password} onChange={handlePasswordChange} placeholder='Пароль' />
            <button className={`${style.btngred}`} onClick={handleLogin}>Далее</button>
            <span onClick={() => {
               setPage(2)
            }}>Я не помню пароль</span>
        </div>
     );
}

export default Auth;